import { MessengerApiError } from './services/messenger.api'

/**
 * Translate a failed group action into a reason worth showing a person.
 *
 * The handlers used to put `err.message` straight into the toast, and that
 * message is written for a log line, not a person: "admin required",
 * "invalid id", "consent required before chat". Two of those do not even
 * describe what went wrong from where the user is standing — being told
 * "invalid id" when you clicked Make Admin on a name in a list is not
 * information, it is noise.
 *
 * Anything unrecognised falls back to the caller's own wording rather than
 * leaking a server string, so a new code added on the server can never start
 * showing up in the UI on its own.
 */
export function groupActionReason(err: unknown, t: (k: string) => string): string | undefined {
  if (!(err instanceof MessengerApiError)) return undefined
  switch (err.code) {
    case 'FORBIDDEN':
    case 'NOT_ADMIN':
      return t('presence.errorAdminOnly')
    case 'NOT_MEMBER':
      return t('presence.errorNotMember')
    case 'NOT_FOUND':
      return t('presence.errorMemberGone')
    case 'GROUP_FULL':
    case 'GROUP_CAP_EXCEEDED':
      return t('presence.errorGroupFull')
    case 'NO_CONTACT':
      return t('presence.errorChatNotEnabled')
    case 'SERVER_ERROR':
      return t('presence.errorServer')
    default:
      // Includes VALIDATION_ERROR: the server's wording for it describes a
      // request shape, which is ours to get right, not the user's to read.
      return undefined
  }
}
